import { render, staticRenderFns } from "./StatisticsTradeTransactionsFilters.vue?vue&type=template&id=da58611e&scoped=true&"
import script from "./StatisticsTradeTransactionsFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticsTradeTransactionsFilters.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTradeTransactionsFilters.vue?vue&type=style&index=0&id=da58611e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da58611e",
  null
  
)

export default component.exports